import { FlagList } from '../store/featureFlags';

// Builds the `where` clause for Contentful's bookingAlertCollection, using the same feature flag rule as GlobalWebsite:
// an alert tagged with a flag key is hidden while that flag is off; an alert with no flag tag always shows.
// On/off and venue include/exclude lists live in ConfigCat rules on the `venueCode` user attribute.
// Returns undefined when no flag is off, as nothing needs filtering.
export function buildBookingAlertWhere(flags: FlagList): string | undefined {
    const disabledFlags = Object.keys(flags).filter((key) => !flags[key]?.enabled);

    if (disabledFlags.length === 0) {
        return undefined;
    }

    return `{ contentfulMetadata: { tags: { id_contains_none: ${JSON.stringify(disabledFlags)} } } }`;
}
